import { ElementRef, Injectable } from '@angular/core';
import { HeaderVisiblityService } from '@app/services/header-visibility.service';
import { LayoutService } from '@app/services/layout.service';

@Injectable()
export class ChaptersFocusModeService {
  public isFocusMode = false;

  constructor(
    private readonly headerVisibilityService: HeaderVisiblityService,
    private readonly layoutService: LayoutService) { }

  public toggleFocusMode(): void {
    this.layoutService.toggleContentOnlyMode();

    if (this.layoutService.contentOnlyModeValue) {
      this.enableFocusMode();
      return;
    } 
    
    this.disableFocusMode();
  }

  public enableFocusMode(): void {  
    this.isFocusMode = true;
    this.headerVisibilityService.collapseHeader();
  }

  public disableFocusMode(): void {
    this.isFocusMode = false;
    this.headerVisibilityService.setDefaultHeader();
  }
}